import React from "react";
import { Card, Text, Grid } from "@nextui-org/react";
import { motion } from "framer-motion";

const AltAnalyticsKPIGrid = ({ metrics = {} }) => {
  const {
    shopTotal = 0,
    sunilC = 0,
    customerTotal = 0,
    profit = 0,
  } = metrics;

  return (
    <motion.div className="alignDivCenter" style={{ marginTop: "5px" }}>
      <Grid.Container gap={1} justify="center" css={{ mw: "1000px" }}>
        <Grid xs={6} sm={3}>
          <Card variant="flat" css={{ bg: "$warningLight", p: "12px" }}>
            <Text size="11px" b transform="uppercase" color="$warning">
              Shop Total
            </Text>
            <Text size="18px" b color="warning">
              &#8377; {Math.ceil(shopTotal).toLocaleString("en-IN")}
            </Text>
          </Card>
        </Grid>

        <Grid xs={6} sm={3}>
          <Card variant="flat" css={{ bg: "$red50", p: "12px" }}>
            <Text size="11px" b transform="uppercase" color="$red800">
              Sunil C
            </Text>
            <Text size="18px" b color="error">
              &#8377; {Math.ceil(sunilC).toLocaleString("en-IN")}
            </Text>
          </Card>
        </Grid>

        <Grid xs={6} sm={3}>
          <Card variant="flat" css={{ bg: "$gray100", p: "12px" }}>
            <Text size="11px" b transform="uppercase" color="$gray800">
              Customer
            </Text>
            <Text size="18px" b color="default">
              &#8377; {Math.ceil(customerTotal).toLocaleString("en-IN")}
            </Text>
          </Card>
        </Grid>

        <Grid xs={6} sm={3}>
          <Card variant="flat" css={{ bg: profit >= 0 ? "$blue50" : "$red50", p: "12px" }}>
            <Text size="11px" b transform="uppercase" color={profit >= 0 ? "$blue800" : "$red800"}>
              Profit
            </Text>
            <Text size="18px" b color={profit >= 0 ? "secondary" : "error"}>
              &#8377; {Math.ceil(profit).toLocaleString("en-IN")}
            </Text>
          </Card>
        </Grid>
      </Grid.Container>
    </motion.div>
  );
};

export default AltAnalyticsKPIGrid;
